<script setup lang="ts">
import TextDivider from "@/components/TextDivider.vue";
import LoggedOut from "@/layouts/LoggedOut.vue";
import type { redirectSchema } from "@/router/dtos";
import { ref } from "vue";
import * as z from "zod/v4-mini";
import { useCreateSignup } from "./useCreateSignup";

const { redirect } = defineProps<{
  redirect: z.infer<typeof redirectSchema>;
}>();

const { signup, isSuccess } = useCreateSignup(redirect);

const email = ref("");
</script>

<template>
  <LoggedOut>
    <template v-if="isSuccess">
      <h2>Deine Registrierung ist fast abgeschlossen! 🌟</h2>
      <p>
        Schau in deine Mails, um dir einen Account einzurichten. Wir freuen uns
        schon auf dich!
      </p>
    </template>
    <template v-else>
      <p><strong>Hey, schön dich zu sehen!</strong></p>
      <div class="column column-lg">
        <form @submit.prevent="signup(email)">
          <div class="column column-md">
            <label for="email">
              Bitte gib deine E-Mail Adresse an, um deinen Account zu erstellen:
            </label>
            <input
              id="email"
              v-model="email"
              type="email"
              name="email"
              autocomplete="email"
              required
              autofocus
              placeholder="E-Mail-Adresse"
            />
            <button type="submit" class="button fullwidth">Registrieren</button>
          </div>
        </form>
        <div class="column">
          <TextDivider>Schon einen Account?</TextDivider>
          <RouterLink
            :to="{ name: 'login', query: redirect }"
            class="button button--secondary fullwidth"
            role="button"
          >
            Login
          </RouterLink>
        </div>
      </div>
    </template>
  </LoggedOut>
</template>

<style scoped>
.fullwidth {
  width: 100%;
  justify-content: center;
}
</style>
